// src/constants/orgRoles.js
//
// Single source of truth for org role values + display labels.
// Values must match aiprime.roles.name exactly.
//
// Project roles live separately in projectRoles.js — different axis.

export const ORG_ROLE_OPTIONS = [
  { value: "org_admin",  label: "Admin"  },
  { value: "org_member", label: "Member" },
];

export const ORG_ROLE_LABEL = Object.fromEntries(
  ORG_ROLE_OPTIONS.map(r => [r.value, r.label])
);

export const DEFAULT_ORG_INVITE_ROLE = "org_member";